import { Type } from 'class-transformer';
import { IsArray, IsString, IsUUID, ValidateNested } from 'class-validator';

class AllergenDiscrepancyLinkDto {
  @IsUUID()
  linkedLotId!: string;

  @IsString()
  ingredientKey!: string;
}

export class AllergenDiscrepancyRequestDto {
  @IsUUID()
  recipeId!: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => AllergenDiscrepancyLinkDto)
  links!: AllergenDiscrepancyLinkDto[];
}

class AllergenDiscrepancyAllergenEntryDto {
  @IsUUID()
  allergenId!: string;

  @IsString()
  category!: 'CONTAINS' | 'MAY_CONTAIN';
}

class AllergenDiscrepancyDowngradeEntryDto {
  @IsUUID()
  allergenId!: string;
}

export class AllergenDiscrepancyRowDto {
  ingredientKey!: string;
  productName!: string;
  fromIngredient!: AllergenDiscrepancyAllergenEntryDto[];
  fromLot!: AllergenDiscrepancyAllergenEntryDto[];
  /** Presenti sull'anagrafica, assenti dal lotto: la modifica pericolosa, va mostrata per prima. */
  removed!: AllergenDiscrepancyAllergenEntryDto[];
  /** Presenti sul lotto, assenti dall'anagrafica. */
  added!: AllergenDiscrepancyAllergenEntryDto[];
  /** CONTAINS sull'anagrafica declassato a MAY_CONTAIN sul lotto. */
  downgraded!: AllergenDiscrepancyDowngradeEntryDto[];
}

export class AllergenDiscrepancyResponseDto {
  rows!: AllergenDiscrepancyRowDto[];
  hasDiscrepancy!: boolean;
}
